import { useState } from "react";
import { FiCopy, FiCheck } from "react-icons/fi";
import toast from "react-hot-toast";

const CopyButton = ({ copy }) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    toast.success("Copied to clipboard");
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2500);
  };

  return (
    <div
      onClick={() => copyToClipboard(copy ?? "")}
      className="hover:bg-N40 p-1 rounded cursor-pointer"
    >
      {copied ? (
        <FiCheck size="12px" className="text-success-600 active:text-B200" />
      ) : (
        <FiCopy size="12px" className="text-B100 active:text-B200" />
      )}
    </div>
  );
};

export default CopyButton;
